import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useClutch } from "./ClutchContext";

const Instructions = () => {
  const navigate = useNavigate();
  const { config } = useClutch();
  const [consent, setConsent] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const openPrivacy = (e) => { e.stopPropagation(); e.preventDefault(); setShowPrivacy(true); };

  return (
    <div className="cl-root">
      <div className="cl-bg" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/stadium-bg.png)` }} />
      <div className="cl-wrap cl-scroll">
        <div className="cl-row">
          <div className="cl-logo"><b>Care</b><span>Plix</span><sup>✛</sup></div>
          <div className="cl-badge">STEP 2 / 3</div>
        </div>

        <div style={{ marginTop: 22 }}>
          <div className="cl-kicker">HOW IT WORKS</div>
          <h1 className="cl-title" style={{ fontSize: "clamp(34px,10vw,46px)", marginTop: 8 }}>Hold your<br />nerve.</h1>
        </div>

        <div className="cl-steps" style={{ marginTop: 24 }}>
          <div className="cl-step">
            <div className="n">1</div>
            <div className="t"><b>Hold your phone at arm's length</b>, face centred and well-lit. Keep your head still — that's how we read your pulse.</div>
          </div>
          <div className="cl-step">
            <div className="n">2</div>
            <div className="t">For <b>{config.scanDurationSec} seconds</b> you'll take penalty after penalty. Tap once to lock your aim, tap again for power.</div>
          </div>
          <div className="cl-step">
            <div className="n">3</div>
            <div className="t">A live BPM read-out climbs as the pressure builds. <b>Stay calm, keep scoring</b> — your composure is the real score.</div>
          </div>
        </div>

        <div
          className="cl-consent"
          style={{ marginTop: 22 }}
          onClick={() => setConsent((c) => !c)}
        >
          <div className={"cl-check" + (consent ? " on" : "")}>
            {consent && (
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="m5 12 5 5L19 7" stroke="#04211f" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>
            )}
          </div>
          <div>
            <b style={{ color: "#dbe7f5" }}>I consent to camera-based pulse measurement and data sharing.</b> My face is
            analysed in real time to measure heart-rate (no video is recorded or stored), and I agree
            to share my details and assessment results with the partner sponsoring this assessment. See our{" "}
            <button type="button" className="cl-link" onClick={openPrivacy}>Privacy Policy</button>.
          </div>
        </div>

        <div className="cl-spacer" />
        <button className="cl-btn" disabled={!consent} onClick={() => navigate("/play")} style={{ marginTop: 18 }}>
          I'm Ready — Allow Camera
        </button>
        <p className="cl-foot" style={{ marginTop: 10 }}>Camera permission is requested on the next screen</p>
      </div>

      {showPrivacy && (
        <div className="cl-modal-bg" onClick={() => setShowPrivacy(false)}>
          <div className="cl-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Privacy Policy &amp; Data Consent</h3>
            <div className="cl-policy">
              <h4>What we measure</h4>
              <p>
                CarePlix Pressure CAM uses your device camera to estimate your pulse from subtle colour changes in
                your face (remote photoplethysmography). The camera feed is processed in real time to
                derive heart-rate and related wellness indicators only.
              </p>

              <h4>What we do <em>not</em> do</h4>
              <p>
                No video or photo of your face is recorded, saved, or transmitted anywhere. The live
                camera frames are used transiently for measurement and are discarded immediately.
              </p>

              <h4>Information you provide</h4>
              <p>
                To personalise your scan you share your name, age, gender, height, weight and mobile
                number, which is verified via a one-time password (OTP). These details are sent to the
                CarePlix scan service to generate your vitals report.
              </p>

              <h4>Data sharing consent</h4>
              <p>
                This assessment is sponsored by a partner. By taking part you consent to us sharing the
                details you provide (name, age, gender, height, weight, mobile number) and your
                assessment results with the third-party partner sponsoring this assessment, so they can
                contact you and provide related services. Your data is not sold to anyone else.
              </p>
              <p>
                Additionally, if you request a full body check-up or tap a partner offer on the results
                screen, you also consent to us sharing your name, phone number and (if provided) email
                with our health support partner so they can contact you about that service.
              </p>

              <h4>Your choices</h4>
              <p>
                Participation is voluntary and this experience is for wellness and demonstration
                purposes only — it is not a medical diagnosis. You may stop the scan at any time.
              </p>
            </div>
            <button className="cl-btn" style={{ marginTop: 18 }} onClick={() => setShowPrivacy(false)}>Got it</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Instructions;
